import {
  LICENSING_MODE_PRIVATE_COHORTS,
  LICENSING_MODE_SCHOOL_LICENSING
} from "../../store/resource/offering/license/constants"

export const getMinSeats = (licenseOffering) => {
  const {
    minimum_seat_count,
    include_creator_seat,
    included_in_user_subscription
  } = licenseOffering

  const baseMinSeats = Math.max(
    minimum_seat_count,
    !include_creator_seat ? 1 : 0
  )

  // Enforce minimum seat count of 1 if user's seat is not included
  switch (licenseOffering.licensing_mode) {
    case LICENSING_MODE_SCHOOL_LICENSING:
      return baseMinSeats
    case LICENSING_MODE_PRIVATE_COHORTS:
      // subscriber does not need to purchase seats
      return included_in_user_subscription ? 0 : baseMinSeats
    default:
      return minimum_seat_count
  }
}
